import { GriboullisIcon } from "@images/svgIcons/griboullisIcon"
import { useUser } from "@modules/auth/hooks/useUser"
import { useBoxStaffInvitationSidebar } from "@modules/boxStaff/hooks/useBoxStaffInvitationSidebar"
import { useServicesContext } from "@modules/core/services/services.context"
import { word } from "@modules/core/utils/i18n"
import { NewsResume } from "@modules/dashboard/components/newsResume"
import { ObjectivesResume } from "@modules/dashboard/components/objectivesResume"
import { ProfileResume } from "@modules/dashboard/components/profileResume"
import { RightNowResume } from "@modules/dashboard/components/rightNowResume"
import { SessionsResume } from "@modules/dashboard/components/sessionsResume"
import { StripeAccountErrorAlert } from "@modules/finances/components/stripeAccountErrorAlert"
import { useHome } from "@modules/home/hooks/useHome"
import { useMemberSideBar } from "@modules/members/hooks/useMemberSidebar"
import { useProgramBundleSidebar } from "@modules/programBundle/hooks/useProgramBundleSidebar"
import { useInvitationSidebar } from "@modules/sharedCoach/hooks/useInvitationSidebar"
import { LocalStorageKeys } from "@modules/storage/localStorageKeys"
import { HUText } from "@modules/ui/components/huText"
import { useEffect } from "react"
import styled, { useTheme } from "styled-components"

export const DashboardPage: React.FC = () => {
  const user = useUser()
  const theme = useTheme()
  const { navigateToInvitationDetailsInfo } = useInvitationSidebar()
  const { navigateToBoxStaffInvitation } = useBoxStaffInvitationSidebar()
  const { navigateToProgramBundleResume } = useProgramBundleSidebar()
  const { navigateToMemberOfferInvitation } = useMemberSideBar()
  const { homeContent } = useHome()
  const { localStorageService } = useServicesContext()

  const programId = localStorage.getItem(LocalStorageKeys.sharedCoachInvitation.programId)
  const boxId = localStorage.getItem(LocalStorageKeys.boxStaffInvitation.boxId)
  const programBundleInvitation = localStorageService.load(LocalStorageKeys.programBundleInvitation, {
    programBundleId: "",
  })
  const boxOfferInvitation = localStorageService.load(LocalStorageKeys.boxOfferInvitation.invitation, {
    boxId: "",
    boxOfferId: "",
    shortLink: "",
  })

  useEffect(() => {
    const timer = setTimeout(() => {
      if (boxId && boxId !== "") {
        navigateToBoxStaffInvitation({
          onHide: () => {
            localStorage.removeItem(LocalStorageKeys.boxStaffInvitation.boxId)
            return Promise.resolve(true)
          },
        })
      }

      if (programId && programId !== "") {
        navigateToInvitationDetailsInfo({
          onHide: () => {
            localStorage.removeItem(LocalStorageKeys.sharedCoachInvitation.programId)
            return Promise.resolve(true)
          },
          replaceAllComponents: true,
        })
      }

      if (programBundleInvitation && programBundleInvitation.programBundleId !== "") {
        navigateToProgramBundleResume(programBundleInvitation.programBundleId, false)

        localStorage.removeItem(LocalStorageKeys.programBundleInvitation)
      }

      if (
        boxOfferInvitation &&
        boxOfferInvitation.boxOfferId !== "" &&
        boxOfferInvitation.shortLink !== "" &&
        boxOfferInvitation.boxId !== ""
      ) {
        localStorage.removeItem(LocalStorageKeys.boxOfferInvitation.invitation)

        navigateToMemberOfferInvitation(boxOfferInvitation)
      }
    }, 2000)

    return () => {
      clearInterval(timer)
    }
  }, [programId, boxId])

  return (
    <>
      <Container>
        <ColOneContainer>
          {user && <ProfileResume user={user} />}
          <HustleToday>
            <HUText fontStyle="BM">{word("home.screen.title", { firstname: user?.firstname })}</HUText>
            <HUText fontStyle="HM">{word("home.screen.subtitle")}</HUText>
            <GribouillisIconStyled color={theme.primaryColor} />
          </HustleToday>
          <SessionsResume />
        </ColOneContainer>
        <ColTwoContainer>
          {homeContent?.shouldDisplayRightNowSection() && <RightNowResume />}
          <ObjectivesResume />
        </ColTwoContainer>
        <ColNewsContainer>
          <StripeAccountErrorAlert orientation="vertical" />
          <NewsResume />
        </ColNewsContainer>
      </Container>
    </>
  )
}
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: calc(100vh - 3.6rem);
  justify-content: space-between;
  width: 100%;
  min-height: 670px;
`

const ColOneContainer = styled.div`
  width: 32%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  @media screen and (max-width: 1480px) {
    width: 49%;
  }
  @media screen and (max-width: 1180px) {
    height: unset;
    width: 100%;
  }
`
const ColTwoContainer = styled.div`
  width: 36%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 15px;

  @media screen and (max-width: 1480px) {
    width: 49%;
  }
  @media screen and (max-width: 1180px) {
    height: unset;
    width: 100%;
  }
`
const ColNewsContainer = styled.div`
  width: 28%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  @media screen and (max-width: 1480px) {
    margin-top: 10px;
    width: 100%;
    height: unset;
  }
`

const HustleToday = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  margin-bottom: 25px;
  position: relative;
`

const GribouillisIconStyled = styled(GriboullisIcon)`
  position: absolute;
  bottom: 22px;
  left: 232px;
`
